module.exports = __webpack_public_path__ + "static/media/woman-working-on-a-laptop2.97a784e7.jpg";